import {parseReferrer, ROUTE_REF_PREFIX, ROUTE_REF_REGEX} from '@/utils/portuna';
import {Component, Vue} from 'vue-facing-decorator';
import {type RouteLocationRaw} from 'vue-router';

@Component({
    name: 'RouterUtils',
    methods: {
        parseReferrer,
    }
})
class RouterUtils extends Vue
{
    routerGoBack(fallbackRoute: RouteLocationRaw = '/', followRef = true)
    {
        let ref = followRef && this.getCurrentRefParam();

        if (ref)
        {
            this.$router.push(ref).catch(console.error);
        }
        // actually "=== 1" but vue seems to have a default push, thus 2
        else if (window.history.length <= 2)
        {
            this.$router.push(fallbackRoute).catch(console.error);
        }
        else
        {
            this.$router.go(-1);
        }
    }

    getCurrentRefParam()
    {
        if (this.$router.currentRoute?.value?.params?.ref)
        {
            return parseReferrer(this.$router.currentRoute?.value?.params?.ref);
        }

        return '';
    }

    resolveRef()
    {
        let ref = this.getCurrentRefParam();

        return ref ? this.$router.resolve(ref) : null;
    }

    redirect(url: RouteLocationRaw | string, replace = true)
    {
        const method = replace ? 'replace' : 'push';

        if ('string' === typeof url)
        {
            let match = this.$router.resolve(url);

            if (this.$router.currentRoute.value.fullPath !== match.fullPath)
            {
                this.$router[method]({
                    path: url,
                }).catch(console.error);
            }
        }
        else
        {
            this.$router[method](url).catch(console.error);
        }
    }

    getReferrer()
    {
        let refRecursionReplace = new RegExp('/' + ROUTE_REF_REGEX);
        return ROUTE_REF_PREFIX + btoa(this.$router.currentRoute.value.fullPath.replace(refRecursionReplace, ''));
    }
}

export default RouterUtils;